var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7642",
    "data-name": "Group 7642",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2409",
    "data-name": "Rectangle 2409",
    width: 17,
    height: 17,
    fill: "none",
    stroke: "#2b1e3f",
    strokeWidth: 1.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5386",
    "data-name": "Group 5386",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M15.775,7.081H4.724L5.381,17.2a1.244,1.244,0,0,0,1.241,1.163h7.255A1.244,1.244,0,0,0,15.118,17.2Z",
    transform: "translate(-1.75 -2.623)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    x1: 14.893,
    transform: "translate(1.053 4.459)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M14.817,5.2V3.105A1.105,1.105,0,0,0,13.711,2H9.524A1.105,1.105,0,0,0,8.418,3.105V5.2",
    transform: "translate(-3.118 -0.741)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    y2: 4.909,
    transform: "translate(10.145 7.658)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    y2: 4.909,
    transform: "translate(6.855 7.658)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteActiveIcon);
export default __webpack_public_path__ + "static/media/delete-active-icon.3384b82c71ace651bc042a29d11504e1.svg";
export { ForwardRef as ReactComponent };